/**
 * - YYYY-MM-DD -> DD/MM/YYYY
 */
export function apiDateToUiDate(date: string | undefined): string | undefined {
  if (!date) return undefined;

  const birthDate = new Date(date);
  const day = String(birthDate.getDate()).padStart(2, '0');
  const month = String(birthDate.getMonth() + 1).padStart(2, '0');
  const year = birthDate.getFullYear();
  return `${day}/${month}/${year}`;
}

/**
 * - DD/MM/YYYY -> YYYY-MM-DD
 */
export function uiDateToApiDate(date: string | undefined): string {
  if (!date) return '';
  if (date.indexOf('-') !== -1) return date;

  return date.split('/')?.reverse().join('-');
}

/**
 * Parse "DD/MM/YYYY" string into Date
 */
export const parseStringToDate = (regDate: string): Date => {
  const [day, month, year] = regDate.split('/').map(Number);
  return new Date(year, month - 1, day);
};
